import React from 'react';
import { BriefcaseIcon } from 'lucide-react';
import type { PM } from './useProductManager';
import { useDarkClasses } from '../../../hooks/useDarkClasses';
interface AvailabilityServicesSectionProps {
  pm: PM;
}
export const AvailabilityServicesSection: React.FC<AvailabilityServicesSectionProps> = ({
  pm
}) => {
  const dk = useDarkClasses();
  const {
    darkMode,
    productType,
    creativeForm,
    setCreativeForm,
    serviceForm,
    setServiceForm,
    willDoInput,
    setWillDoInput,
    wontDoInput,
    setWontDoInput,
    handleAddService,
    handleUpdateService,
    handleRemoveService,
    handleAddServiceService,
    handleUpdateServiceService,
    handleRemoveServiceService,
    handleAddBoundary,
    handleRemoveBoundary
  } = pm;
  return <div className={`p-6 rounded-xl shadow-sm ${dk.card}`} data-id="element-19887" data-mp="1aa2h4rgwvz2b">
      <h2 className={`text-lg font-bold mb-4 flex items-center ${dk.textHeading}`} data-id="element-19888" data-mp="1aaklkbdq9jlb">
        <BriefcaseIcon className="w-5 h-5 mr-2 text-purple-500" data-id="element-19889" data-mp="15cj3nts1fqbf" />
        Availability & Services
      </h2>
      <div className="space-y-6" data-id="element-19890" data-mp="196t954xs7df9">
        <div data-id="element-19891" data-mp="1e41pczzdd7dv">
          <label className={`block text-sm font-medium mb-2 ${dk.textSecondary}`} data-id="element-19892" data-mp="1e3jotr5oc705">
            Queue Status
          </label>
          <div className="flex gap-4" data-id="element-19893" data-mp="1i4byummdefxh">
            {(['open', 'waitlist', 'closed'] as const).map(status => <label key={status} className="flex items-center space-x-2" data-id="element-19894" data-mp="1n2dfl0wbq35s">
                <input type="radio" checked={(productType === 'creative' ? creativeForm.queueStatus : serviceForm.queueStatus) === status} onChange={() => productType === 'creative' ? setCreativeForm({
              ...creativeForm,
              queueStatus: status
            }) : setServiceForm({
              ...serviceForm,
              queueStatus: status
            })} className="text-purple-600" data-id="element-19895" data-mp="1s3b6q2zba7jf" />
                <span className={`capitalize text-sm ${dk.textPrimary}`} data-id="element-19896" data-mp="pgz2yy7qb9jl">
                  {status}
                </span>
              </label>)}
          </div>
        </div>
        <div className="grid grid-cols-2 gap-4" data-id="element-19897" data-mp="koflvr9u1wa1">
          <div data-id="element-19898" data-mp="ygm4rl4dehd6">
            <label className={`block text-sm font-medium mb-1 ${dk.textSecondary}`} data-id="element-19899" data-mp="yg2kvyv5tiwi">
              Slots Available
            </label>
            <input type="number" value={(productType === 'creative' ? creativeForm.slotsAvailable : serviceForm.slotsAvailable) || 0} onChange={e => productType === 'creative' ? setCreativeForm({
            ...creativeForm,
            slotsAvailable: parseInt(e.target.value)
          }) : setServiceForm({
            ...serviceForm,
            slotsAvailable: parseInt(e.target.value)
          })} className={`w-full p-2 rounded-md border ${dk.inputOnCard}`} data-id="element-19900" data-mp="18gcvdbpt8c7z" />
          </div>
          <div data-id="element-19901" data-mp="1fxj5dub9x5fn">
            <label className={`block text-sm font-medium mb-1 ${dk.textSecondary}`} data-id="element-19902" data-mp="1fwzq6ld0cv5b">
              Max Slots
            </label>
            <input type="number" value={(productType === 'creative' ? creativeForm.maxSlots : serviceForm.maxSlots) || 0} onChange={e => productType === 'creative' ? setCreativeForm({
            ...creativeForm,
            maxSlots: parseInt(e.target.value)
          }) : setServiceForm({
            ...serviceForm,
            maxSlots: parseInt(e.target.value)
          })} className={`w-full p-2 rounded-md border ${dk.inputOnCard}`} data-id="element-19903" data-mp="16zfkn0844cow" />
          </div>
        </div>
        <div data-id="element-19904" data-mp="idejfvr7chq2">
          <label className={`block text-sm font-medium mb-1 ${dk.textSecondary}`} data-id="element-19905" data-mp="dcqstb6vy2wd">
            Estimated Wait
          </label>
          <input type="text" value={(productType === 'creative' ? creativeForm.estimatedWait : serviceForm.estimatedWait) || ''} onChange={e => productType === 'creative' ? setCreativeForm({
          ...creativeForm,
          estimatedWait: e.target.value
        }) : setServiceForm({
          ...serviceForm,
          estimatedWait: e.target.value
        })} className={`w-full p-2 rounded-md border ${dk.inputOnCard}`} placeholder="e.g. 2-3 weeks" data-id="element-19906" data-mp="8eyqdn8m6ydx" />
        </div>
        <div data-id="element-19907" data-mp="3bqg93360vvji">
          <div className="flex justify-between items-center mb-2" data-id="element-19908" data-mp="3gnggbhelz4c7">
            <label className={`block text-sm font-medium ${dk.textSecondary}`} data-id="element-19909" data-mp="3go807uyufdmn">
              Services
            </label>
            <button onClick={productType === 'creative' ? handleAddService : handleAddServiceService} className="text-sm text-purple-600 font-medium" data-id="element-19910" data-mp="3lk6uu0arlrvi">
              + Add Service
            </button>
          </div>
          <div className="space-y-4" data-id="element-19911" data-mp="32o704hqeka88">
            {(productType === 'creative' ? creativeForm.services : serviceForm.services)?.map((service, idx) => <div key={idx} className={`p-4 rounded-lg border ${dk.surfaceMuted} ${dk.border}`} data-id="element-19912" data-mp="2a74bwyl70q86">
                <div className="grid grid-cols-2 gap-2 mb-2" data-id="element-19913" data-mp="2253u76y0vmtm">
                  <input placeholder="Service Name" value={service.name} onChange={e => productType === 'creative' ? handleUpdateService(idx, 'name', e.target.value) : handleUpdateServiceService(idx, 'name', e.target.value)} className={`p-2 rounded border text-sm ${dk.inputOnCard}`} data-id="element-19914" data-mp="1x84xqhqvz3s9" />
                  <input placeholder="Price" value={service.price} onChange={e => productType === 'creative' ? handleUpdateService(idx, 'price', e.target.value) : handleUpdateServiceService(idx, 'price', e.target.value)} className={`p-2 rounded border text-sm ${dk.inputOnCard}`} data-id="element-19915" data-mp="1o6dvxnzgvh3o" />
                </div>
                <textarea placeholder="Description" rows={2} value={service.description} onChange={e => productType === 'creative' ? handleUpdateService(idx, 'description', e.target.value) : handleUpdateServiceService(idx, 'description', e.target.value)} className={`w-full p-2 rounded border mb-2 text-sm ${dk.inputOnCard}`} data-id="element-19916" data-mp="325yy12s105gx" />
                <button onClick={() => productType === 'creative' ? handleRemoveService(idx) : handleRemoveServiceService(idx)} className="text-red-500 text-sm" data-id="element-19917" data-mp="hh2t1zlkvpal">
                  Remove
                </button>
              </div>)}
          </div>
        </div>
        <div className="grid grid-cols-2 gap-4" data-id="element-19918" data-mp="3a7odw6k94pqj">
          <div data-id="element-19919" data-mp="bo7nygq65c00">
            <label className={`block text-sm font-medium mb-2 ${dk.textSecondary}`} data-id="element-19920" data-mp="bor7u2zdqago">
              Will Do
            </label>
            <div className="flex gap-2 mb-2" data-id="element-19921" data-mp="6nbku5dn5tvn">
              <input value={willDoInput} onChange={e => setWillDoInput(e.target.value)} className={`flex-1 p-2 rounded border text-sm ${dk.inputOnCard}`} placeholder="Add..." data-id="element-19922" data-mp="1pigzizt9byj" />
              <button onClick={() => handleAddBoundary('will')} className="px-3 bg-green-600 text-white rounded text-sm" data-id="element-19923" data-mp="2me68ot684kt5">
                +
              </button>
            </div>
            <ul className="space-y-1" data-id="element-19924" data-mp="11xyowb7ru08u">
              {(productType === 'creative' ? creativeForm.willDo : serviceForm.willDo)?.map((item, idx) => <li key={idx} className={`flex justify-between text-sm ${dk.textPrimary}`} data-id="element-19925" data-mp="1botcbiwr75vv">
                  <span data-id="element-19926" data-mp="1gmusnw2sor3n">{item}</span>
                  <button onClick={() => handleRemoveBoundary('will', idx)} className="text-red-500" data-id="element-19927" data-mp="1kozjyo5rtbn4">
                    ×
                  </button>
                </li>)}
            </ul>
          </div>
          <div data-id="element-19928" data-mp="1ul2xsr9ziypw">
            <label className={`block text-sm font-medium mb-2 ${dk.textSecondary}`} data-id="element-19929" data-mp="3rffjs4u089df">
              Won't Do
            </label>
            <div className="flex gap-2 mb-2" data-id="element-19930" data-mp="9xob6c7vs2n">
              <input value={wontDoInput} onChange={e => setWontDoInput(e.target.value)} className={`flex-1 p-2 rounded border text-sm ${dk.inputOnCard}`} placeholder="Add..." data-id="element-19931" data-mp="ct7za0o4t7pb" />
              <button onClick={() => handleAddBoundary('wont')} className="px-3 bg-red-600 text-white rounded text-sm" data-id="element-19932" data-mp="mpui6jwwdoop">
                +
              </button>
            </div>
            <ul className="space-y-1" data-id="element-19933" data-mp="vpzmgl6so6yn">
              {(productType === 'creative' ? creativeForm.wontDo : serviceForm.wontDo)?.map((item, idx) => <li key={idx} className={`flex justify-between text-sm ${dk.textPrimary}`} data-id="element-19934" data-mp="15jzyz84eoehe">
                  <span data-id="element-19935" data-mp="1ejd27j1xs6to">{item}</span>
                  <button onClick={() => handleRemoveBoundary('wont', idx)} className="text-red-500" data-id="element-19936" data-mp="1ekepqn052lsa">
                    ×
                  </button>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </div>;
};